/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions} from 'angular';
import RoleUtilService from '../../../core/service/RoleUtilService';
import {getLeistungsartValues, leistungsartPrefix, TSLeistungsart} from '../../../models/enums/TSLeistungsart';
import TSFremdkosten from '../../../models/TSFremdkosten';
import TSFremdkostenDaten from '../../../models/TSFremdkostenDaten';
import ILogService = angular.ILogService;
import ITranslateService = angular.translate.ITranslateService;

declare let require: any;
declare let angular: any;

export class DVFremdkostenComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        fremdkosten: '=',
        name: '@',
    };
    template = require('./dv-fremdkosten.html');
    controller = DVFremdkostenController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DVFremdkostenController {

    fremdkosten: TSFremdkosten;
    name: string;

    static $inject: any[] = ['CONSTANTS', '$log', 'RoleUtilService', '$translate'];

    /* @ngInject */
    constructor(private CONSTANTS: any, private $log: ILogService, private roleUtilService: RoleUtilService,
                private $translate: ITranslateService,
    ) {
        this.$log.debug('initializing fremdkosten componente');

    }

    $onInit() {
        if (this.fremdkosten === undefined || this.fremdkosten === null) {
            this.fremdkosten = new TSFremdkosten();
            this.fremdkosten.fremdkostenDatenFS = new TSFremdkostenDaten();
        }

    }

    public getModel(): TSFremdkosten {
        return this.fremdkosten;
    }

    public getTSLeistungsartenValues(): Array<TSLeistungsart> {
        return getLeistungsartValues(this.fremdkosten.schaetzung);
    }

    public translateLeistungsart(leistugnsart: TSLeistungsart): string {
        let translationKey = leistungsartPrefix() + TSLeistungsart[leistugnsart];
        return this.$translate.instant(translationKey)

    }

    public getPrefix(): string {
        return leistungsartPrefix();
    }
}




// WEBPACK FOOTER //
// ./src/app/gesuch/component/dv-fremdkosten/dv-fremdkosten.ts